import { fetchSimilarTenders } from '@/actions/tenders';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import { parseFileNameFromContentDisposition } from '@/utils/downloadUtil';

export const getSimilarTenders = async (data: any, isAnonymous = false) => {
  if (isAnonymous) {
    return fetchSimilarTenders(data);
  } else {
    const userAccessToken = await getUserAccessToken();
    return fetchSimilarTenders(data, userAccessToken);
  }
};

export const exportTimelineEntries = async (tenderId: string) => {
  const userAccessToken = await getUserAccessToken();
  const res = await fetch(`/api/export/timeline?tenderId=${tenderId}`, {
    headers: {
      Authorization: `${userAccessToken}`,
    },
  });

  const contentDisposition = res.headers.get('Content-Disposition');
  const fileName = parseFileNameFromContentDisposition(contentDisposition);
  const blob = await res.blob();

  return { blob, fileName };
};
